module.exports = __webpack_public_path__ + "static/media/IGCSE_subjects.6453fefc.png";